var _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 54",
    role: "img",
    "aria-label": "Dispon\\xEDvel na App Store",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 168,
    height: 52,
    rx: 10,
    fill: "#000000",
    stroke: "#A6A6A6",
    strokeWidth: 1.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,12) scale(1.08)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.543 12.43c-.02-2.18 1.78-3.23 1.86-3.28-1.02-1.49-2.6-1.69-3.16-1.71-1.34-.14-2.62.79-3.3.79-.68 0-1.73-.77-2.85-.75-1.47.02-2.82.85-3.58 2.17-1.53 2.65-.39 6.58 1.1 8.73.73 1.05 1.6 2.23 2.74 2.19 1.1-.04 1.51-.71 2.84-.71 1.32 0 1.7.71 2.85.69 1.18-.02 1.93-1.07 2.65-2.12.84-1.21 1.18-2.39 1.2-2.45-.03-.01-2.3-.88-2.32-3.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.36 5.88c.6-.73 1.01-1.74.9-2.75-.87.04-1.92.58-2.55 1.31-.56.64-1.05 1.67-.92 2.65.97.08 1.96-.49 2.57-1.21z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 22,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fill: "#FFFFFF"
  }, "Dispon\xEDvel na")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 49,
    y: 42,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "App Store")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.4bd5ba26b38a60644ceb29dd293f94ab.svg";
export { ForwardRef as ReactComponent };